;(function(){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: ["synccur", "sycnmerchant", "syncaccount", "switch_api_endpoint"],
  data: function data() {
    return {
      con_key: null,
      con_secret: null,
      admin: null,
      loading: true,
      dt_revenue_today: null,
      hourly_graph_data: [],
      currency: "",
      revenue_today: {
        usd: "USD 0.0",
        default_currency: this.currency + " 0.0",
        invoices: 0,
        customers: 0
      },
      merchant: null,
      service_accounts: []
    };
  },

  watch: {
    synccur: function synccur(val) {
      this.currency = val;
      this.revenue_today.default_currency = val + " " + this.revenue_today.default_currency;
    },
    sycnmerchant: function sycnmerchant(val) {
      this.merchant = val.id;
      this.fetch_revenue_today();
    },
    syncaccount: function syncaccount(val) {
      if (val) {
        this.service_accounts = [val.id];
      }

      this.fetch_revenue_today();
    }
  },
  mounted: function mounted() {
    this.fetch_revenue_today();
  },

  methods: {
    to_human: function to_human(x) {
      if (x == null) return 0;
      var n = this.to_fixed(x);
      return this.formatNumber(n.toLocaleString());
    },
    formatNumber: function formatNumber(num) {
      return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    },
    to_fixed: function to_fixed(val) {
      return (Math.round(val * 100) / 100).toFixed(2);
    },
    to_human_no_fixed: function to_human_no_fixed(x) {
      if (x == null) return 0;
      return x.toLocaleString();
    },
    fetch_revenue_today: function fetch_revenue_today() {
      var _this = this;

      var api_url;

      if (this.switch_api_endpoint) {
        api_url = this.switch_api_endpoint;
      } else {
        api_url = "/api/dashboard/admin/data";
      }
      var params = {
        merchant: this.merchant,
        service_accounts: this.service_accounts,
        stat_type: "revenue_today"
      };

      Vue.axios.post(api_url, params).then(function (response) {
        var content = response.data.content;
        _this.dt_revenue_today = response.data.content.revenue;
        _this.hourly_graph_data = content.graph_data;

        _this.revenue_today = {
          invoices: _this.to_human_no_fixed(_this.dt_revenue_today.invoices),
          usd: "USD " + _this.to_human(parseFloat(_this.dt_revenue_today.usd)),
          default_currency: _this.currency + " " + _this.to_human(parseFloat(_this.dt_revenue_today.default_currency)),
          customers: _this.to_human_no_fixed(_this.dt_revenue_today.customers)
        };
        _this.set_hourly_graph_data();
      }).catch(function () {
        _this.loading = false;
      }).then(function () {
        _this.loading = false;
      });
    },
    set_hourly_graph_data: function set_hourly_graph_data() {
      $("#hourly_graph_data").highcharts({
        chart: {
          renderTo: "hourly_graph_data",
          backgroundColor: null,
          borderWidth: 0,
          type: "areaspline",
          margin: [3, 0, 0, 0],
          height: 40,
          style: {
            overflow: "visible"
          },

          skipClone: true
        },
        title: {
          text: ""
        },
        exporting: {
          enabled: false
        },
        credits: {
          enabled: false
        },
        xAxis: {
          gridLineWidth: 0,
          minorGridLineWidth: 0,
          lineColor: "transparent",
          labels: {
            enabled: false
          },
          title: {
            text: null
          },
          startOnTick: false,
          endOnTick: false,
          tickPositions: [],
          alignTicks: false,
          minPadding: 0,
          maxPadding: 0
        },
        yAxis: {
          gridLineWidth: 0,
          minorGridLineWidth: 0,
          lineColor: "transparent",
          endOnTick: false,
          startOnTick: false,
          labels: {
            enabled: false
          },
          title: {
            text: null
          },

          tickPositions: [0]
        },
        legend: {
          enabled: false
        },
        tooltip: {
          enabled: false
        },
        plotOptions: {
          series: {
            animation: false,
            lineWidth: 4,
            shadow: false,
            states: {
              hover: {
                enabled: false
              }
            },
            marker: {
              radius: 0
            }
          }
        },
        series: [{
          lineWidth: 2,
          color: "#9B0000",
          name: "USD Revenue",
          fillColor: {
            linearGradient: [0, 0, 0, 350],
            stops: [[0, "rgb(240,221,222)"], [1, "rgba(255, 255, 255, 0.4)"]]
          },
          data: this.hourly_graph_data.map(function (e) {
            return e.usd;
          }).map(function (e) {
            return parseFloat(e);
          })
        }, {
          lineWidth: 2,
          color: "#9B0000",
          fillColor: {
            linearGradient: [0, 0, 0, 40],
            stops: [[0, "rgb(240,221,222)"], [1, "rgb(255, 255, 255)"]]
          },
          data: this.hourly_graph_data.map(function (e) {
            return e.default_currency;
          }).map(function (e) {
            return parseFloat(e);
          })
        }]
      });
    }
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"card mb-0"},[_c('div',{staticClass:"card-body text-left pb-0"},[_c('h4',[_vm._v("Today")]),_vm._v(" "),_c('p',{staticClass:"mb-1 lead"},[(!_vm.loading)?_c('span',{staticClass:"btn btn-sm btn-light"},[_c('b',[_vm._v(_vm._s(_vm.revenue_today.default_currency))])]):_vm._e(),_vm._v(" "),(_vm.loading)?_c('span',{staticClass:"btn btn-sm btn-light"},[_c('b',[_vm._v("loading...")])]):_vm._e()]),_vm._v(" "),_c('p',{staticClass:"mb-1 lead"},[(!_vm.loading)?_c('span',{staticClass:"btn btn-sm btn-danger"},[_c('b',[_vm._v(_vm._s(_vm.revenue_today.usd))])]):_vm._e(),_vm._v(" "),(_vm.loading)?_c('span',{staticClass:"btn btn-sm btn-danger"},[_c('b',[_vm._v("loading...")])]):_vm._e()])]),_vm._v(" "),_c('div',{attrs:{"id":"hourly_graph_data"}}),_vm._v(" "),_c('div',{staticClass:"card-body d-flex justify-content-between border-top"},[_c('div',[_c('p',{staticClass:"legacy-subtitle mb-0"},[_vm._v("Applications")]),_vm._v(" "),(!_vm.loading)?_c('p',{staticClass:"mb-0 lead"},[_vm._v(_vm._s(_vm.revenue_today.invoices))]):_vm._e(),_vm._v(" "),(_vm.loading)?_c('p',{staticClass:"mb-0 lead"},[_vm._v("loading...")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"text-right"},[_c('p',{staticClass:"legacy-subtitle mb-0"},[_vm._v("Customers")]),_vm._v(" "),(!_vm.loading)?_c('p',{staticClass:"mb-0 lead"},[_vm._v(_vm._s(_vm.revenue_today.customers))]):_vm._e(),_vm._v(" "),(_vm.loading)?_c('p',{staticClass:"mb-0 lead"},[_vm._v("loading...")]):_vm._e()])])])])}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-3413fc46", __vue__options__)
  } else {
    hotAPI.reload("data-v-3413fc46", __vue__options__)
  }
})()}